import { ISeasonRankingPageProps, SeasonRankingPage } from "@sky-it-livedata/livedata-sports-design-system";
import { handleGalleryTabsNavigation } from "../../utils/season-ranking-gallery";
import { TeamTabsWrapperUtils, analyticsClient } from "@sky-it-livedata-libraries/livedata-commons";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { SeasonRankingGalleryQuery } from "./types";
import { useEffect, useRef, useCallback } from "react";
import transformQuery from "./transformers/query-transformer";
import { useIntcmp } from '../../hooks/useIntcmp';
import { initAdv, injectAdv } from '@sky-uk/sky-adv';

export const setCustomAttributes = ({
  variables,
}: WidgetContext<SeasonRankingGalleryQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<SeasonRankingGalleryQuery>): ISeasonRankingPageProps => {
  return transformQuery(props);
}

const ResultsContainer = ({
  props,
  ...rest
}: WidgetContext<ISeasonRankingPageProps>) => {
  log({ props, ...rest });

  const intCmpEventHandler = useIntcmp();
  
  const seasonInstance = useRef<any>(null);

  const seasonsRef = useCallback((node: any) => {
    if (node) {
      seasonInstance.current = node;
      const tabsElements = [...node?.tabsRef?.tabsRef || []];
  
      if (tabsElements && tabsElements.length > 0) {
        tabsElements.forEach((tab: {cardsRef:HTMLElement[]}) => {
          tab.cardsRef.forEach( (card) => {
            trackElementInViewport({ element: card });
          } ) 
        });
      }
    }
  }, []);

  useEffect(() => {
    handleGalleryTabsNavigation(); 
    TeamTabsWrapperUtils.init();
  }, []);

  const trackElementInViewport = (params: { element: HTMLElement }) => {
    const { element } = params;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const item = entry.target as HTMLElement;
          const adv = item.querySelector('[data-card-adv-content]') as HTMLElement | null;

          if (adv && !adv?.querySelector('ins')) {
            injectAdv(adv);
            initAdv(adv);
          }
          analyticsClient.track('change_gallery', { hash: item.dataset.analyticsCard });
        }
      });
    });
    observer.observe(element);
  };


  return (
    <div onClick={intCmpEventHandler}>
      <SeasonRankingPage ref={seasonsRef} {...props} />
    </div>
  );
}

export default ResultsContainer;